import * as React from "react";
import * as yup from "yup";
import { IDropdownItem } from "../IDropdownItem";
import { FormCheckbox, FormGroup, FormInput } from "@/components/bp/bp-ui";
import { TranslationContext } from "../Contexts/TranslationContext";
import { LabClient, CaseClient, ClientResources, AgenciesGetAllResponse } from "@app/api2/api";
import SemanticField from "@app/components/SemanticField";
import { BPForm } from "@common/BPForm";
import { PageHeader } from "@common/PageHeader";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { isNullOrWhitespace, replaceInString } from "@common/Utils";
import { toAlleleFormatName } from "@common/AlleleFormatNames";
import { BPContainer } from "@/components/bp/bpcontainer";

class ICaseEditProps {
    caseId: number;
    labId: number;
}

class CaseEditFormData {
    name: string = '';
    lab: string = '';
    hasQualityControlProfiles: boolean = false;
    agency?: string = '';
    alleleFormat: string = ''
}

class CaseEditState {
    // case: CaseEditFormData = new CaseEditFormData();
    initialValues: CaseEditFormData = new CaseEditFormData();
    loading: boolean = true;
    labList: IDropdownItem<number>[] = [];
    agencyList: IDropdownItem<number>[] = [];
    singleLab: boolean = false;
    serverErrors: string[] = [];
    showServerErrors: boolean = false;
    hasQualityControlProfiles: boolean = false;
}

export class CaseEdit extends React.Component<ICaseEditProps, CaseEditState> {
    translationsContext: React.Context<ClientResources>;
    labClient = new LabClient();
    caseClient = new CaseClient();

    validationSchema: yup.SchemaOf<CaseEditFormData>;

    constructor(props) {
        super(props);
        
        this.state = new CaseEditState();

        this.validationSchema = yup.object().shape({
            name: yup.string().required().label(window.translation.case.name),
            lab: yup.string().required().label(window.translation.lab.name),
            hasQualityControlProfiles: yup.boolean().label(window.translation.case.hasQualityCheckProfiles),
            agency: yup.string(),
            alleleFormat: yup.string()
        });

    }

    async componentDidMount(): Promise<any> {
        const model = await this.caseClient.getCaseBasicInfo(this.props.labId, this.props.caseId);
        const labs = await this.labClient.getAll();

        let mappedLabs = labs.labs.map((l) => ({ key: l.id, value: l.id, text: l.name }));
        let labId = 0;
        let agencies: AgenciesGetAllResponse;
        if (mappedLabs.length) {
            labId = mappedLabs[0].key;
            agencies = await this.labChanged(labId);
        }

        this.setState({
            loading: false,
            labList: mappedLabs,
            initialValues: {
                lab: labs.labs.find(x => x.id == this.props.labId)?.name,
                hasQualityControlProfiles: model.hasQualityCheckProfiles,
                name: model.name,
                agency: agencies.agencies.find(x => x.id == model.agency)?.name,
                alleleFormat: toAlleleFormatName(model.alleleFormat)
            }
        });
    }


    save = async (values: CaseEditFormData): Promise<any> => {
        const caseClient = new CaseClient();

        try {
            const response = await caseClient.updateBasicInfo(this.props.labId, this.props.caseId, {
                name: values.name,
            });

            window.location.assign(buildUrl(AppRoutes.CaseDetails, { labId: this.props.labId, caseId: this.props.caseId }));
        }
        catch (error) {
            if ('modelErrors' in error) {
                // console.log(error)
            }
        }
    }

    async labChanged(labId) {
        const agencies = await this.labClient.getLabAgencies(labId, false, "", "");

        let mappedAgencies = agencies.agencies.map((l) => ({ key: l.id, value: l.id, text: l.name }));

        this.setState({ ...this.state, agencyList: mappedAgencies });

        return agencies;
    }

    render() {
        return (<TranslationContext.Consumer>{t =>
            <BPContainer>
                <PageHeader header={replaceInString(window.translation.caseView.edit, { '{caseName}': this.state.initialValues.name })} />

                <BPForm
                    initialValues={this.state.initialValues}
                    vaildationSchema={this.validationSchema}
                    onSubmit={this.save}
                    onCancel={() => {
                        window.location.assign(buildUrl(AppRoutes.CaseDetails, {
                            caseId: this.props.caseId,
                            labId: this.props.labId
                        }))
                    }}>
                    {(props) => {
                        return <>
                            <SemanticField
                                name="name"
                                component={FormInput}
                                label={t.case.name}
                                width={12} />
                            <FormGroup>
                                {(!this.state.singleLab) &&
                                    <SemanticField
                                        name="lab"
                                        id="lab"
                                        component={FormInput}
                                        readOnly
                                        required
                                        width={6}
                                        label={t.common.lab}
                                    />}

                                {!isNullOrWhitespace(props.values.agency) &&
                                    <SemanticField
                                        name="agency"
                                        id="agency"
                                        component={FormInput}
                                        readOnly
                                        required
                                        width={6}
                                        label={t.common.agency}
                                    />}

                            </FormGroup>

                            <SemanticField
                                readOnly
                                name="hasQualityControlProfiles"
                                component={FormCheckbox}
                                label={t.case.hasQualityCheckProfiles}
                                checked={props.values.hasQualityControlProfiles} />

                            <SemanticField
                                readOnly
                                name="alleleFormat"
                                component={FormInput}
                                label={t.common.alleleFormat}
                                checked={props.values.alleleFormat} />

                        </>
                    }}
                </BPForm>
            </BPContainer>}</TranslationContext.Consumer>);
    }

}